// extracted by mini-css-extract-plugin
module.exports = {"dosage":"Dosage_dosage__dc3gV","thc":"Dosage_thc__nlW2P","cbd":"Dosage_cbd__27W_4"};